import React, { useState } from "react";
import { toast } from "sonner";
import { PowerOff, Loader2 } from "lucide-react";
import { api } from "../../lib/api";
import { Button } from "../ui/button";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";
import {
  Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, DialogTrigger,
} from "../ui/dialog";

const nayaxMessage = (n) => {
  if (!n) return null;
  if (n.ok) return "Stock Nayax réaligné.";
  return `Nayax non réaligné automatiquement (${n.reason || n.error || "indisponible"}) : vérifiez le stock dans MoMa.`;
};

export default function EmptyMachineDialog({ distributorId, distributorName, lotCount, totalQty, onDone }) {
  const [open, setOpen] = useState(false);
  const [notes, setNotes] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/distributors/${distributorId}/empty-to-conthey`, { notes });
      toast.success(`${data.quantity_moved} barquette(s) rapatriée(s) au Stock Conthey`);
      const nm = nayaxMessage(data.nayax);
      if (nm) (data.nayax?.ok ? toast.success : toast.warning)(nm);
      setOpen(false);
      onDone?.();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Erreur lors du rapatriement");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => { setOpen(v); if (v) setNotes(""); }}>
      <DialogTrigger asChild>
        <Button variant="outline" className="border-[#C05C47] text-[#C05C47] hover:bg-[#FCEEEA]" disabled={!totalQty} data-testid="empty-machine-btn">
          <PowerOff className="w-4 h-4 mr-2" /> Vider le distributeur
        </Button>
      </DialogTrigger>
      <DialogContent data-testid="empty-machine-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading">Arrêt machine — {distributorName}</DialogTitle>
          <DialogDescription>
            Les <strong data-testid="empty-machine-qty">{totalQty}</strong> barquette(s) ({lotCount} lot(s)) repartent au Stock Conthey,
            avec le motif « Arrêt machine ». Ce n&apos;est ni une perte ni un retrait facturé au partenaire.
            Vous déciderez ensuite à Conthey du sort de chaque barquette.
          </DialogDescription>
        </DialogHeader>
        <div>
          <Label className="mb-1.5 block">Raison (optionnel)</Label>
          <Textarea rows={2} value={notes} onChange={(e) => setNotes(e.target.value)} placeholder="Ex. : travaux électriques" data-testid="empty-machine-notes" />
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => setOpen(false)} disabled={busy}>Annuler</Button>
          <Button onClick={submit} disabled={busy} className="bg-[#C05C47] hover:bg-[#A04E2C]" data-testid="empty-machine-confirm">
            {busy && <Loader2 className="w-4 h-4 animate-spin mr-2" />} Tout rapatrier
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
